import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const Loading: FC<Props> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{
        margin: "auto",
        background: "rgb(241, 242, 243)",
        display: "block",
        shapeRendering: "auto",
        animationPlayState: "running",
        animationDelay: "0s",
      }}
      width="110px"
      height="110px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      role="img"
      aria-labelledby="titleId"
      aria-label="loader icon"
    >
      {/* <title>loader icon</title> */}
      <circle
        cx={84}
        cy={50}
        r={10}
        fill={props.fill || "currentColor"}
        style={{ animationPlayState: "running", animationDelay: "0s" }}
      >
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="0.4716981132075471s"
          calcMode="spline"
          keyTimes="0;1"
          values="8;0"
          keySplines="0 0.5 0.5 1"
          begin="0s"
          style={{ animationPlayState: "running", animationDelay: "0s" }}
        />
        <animate
          attributeName="fill"
          repeatCount="indefinite"
          dur="1.8867924528301885s"
          calcMode="discrete"
          keyTimes="0;0.25;0.5;0.75;1"
          values="currentColor;currentColor;currentColor;currentColor;currentColor"
          begin="0s"
          style={{ animationPlayState: "running", animationDelay: "0s" }}
        />
      </circle>
      <circle
        cx={16}
        cy={50}
        r={10}
        fill={props.fill || "currentColor"}
        style={{ animationPlayState: "running", animationDelay: "0s" }}
      >
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="1.8867924528301885s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="0;0;8;8;8"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="0s"
          style={{ animationPlayState: "running", animationDelay: "0s" }}
        />
        <animate
          attributeName="cx"
          repeatCount="indefinite"
          dur="1.8867924528301885s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="16;16;16;50;84"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="0s"
          style={{ animationPlayState: "running", animationDelay: "0s" }}
        />
      </circle>
      <circle
        cx={50}
        cy={50}
        r={10}
        fill={props.fill || "currentColor"}
        style={{ animationPlayState: "running", animationDelay: "0s" }}
      >
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="1.8867924528301885s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="0;0;8;8;8"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-0.4716981132075471s"
          style={{ animationPlayState: "running", animationDelay: "0s" }}
        />
        <animate
          attributeName="cx"
          repeatCount="indefinite"
          dur="1.8867924528301885s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="16;16;16;50;84"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-0.4716981132075471s"
          style={{ animationPlayState: "running", animationDelay: "0s" }}
        />
      </circle>
      <circle
        cx={84}
        cy={50}
        r={10}
        fill={props.fill || "currentColor"}
        style={{ animationPlayState: "running", animationDelay: "0s" }}
      >
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="1.8867924528301885s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="0;0;8;8;8"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-0.9433962264150942s"
          style={{ animationPlayState: "running", animationDelay: "0s" }}
        />
        <animate
          attributeName="cx"
          repeatCount="indefinite"
          dur="1.8867924528301885s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="16;16;16;50;84"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-0.9433962264150942s"
          style={{ animationPlayState: "running", animationDelay: "0s" }}
        />
      </circle>
      <circle
        cx={16}
        cy={50}
        r={10}
        fill={props.fill || "currentColor"}
        style={{ animationPlayState: "running", animationDelay: "0s" }}
      >
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="1.8867924528301885s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="0;0;8;8;8"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-1.4150943396226414s"
          style={{ animationPlayState: "running", animationDelay: "0s" }}
        />
        <animate
          attributeName="cx"
          repeatCount="indefinite"
          dur="1.8867924528301885s"
          calcMode="spline"
          keyTimes="0;0.25;0.5;0.75;1"
          values="16;16;16;50;84"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          begin="-1.4150943396226414s"
          style={{ animationPlayState: "running", animationDelay: "0s" }}
        />
      </circle>
    </svg>
  );
};

export default Loading;
